export const storesDescriptions = {
  withSalesData: 'Por tienda, cuántas unidades se han devuelto sobre las unidades vendidas totales.',
  withoutSalesData: 'Qué parte de las unidades devueltas corresponde a cada tienda.',
}
